import { FormGroup } from "@angular/forms";
import { BehaviorSubject, Subscription, of } from "rxjs";
import { AppInjector } from "./app-injector";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { ConfirmationDialogService } from "../providers/confirmation-dialog/confirmation-dialog.service";
import { App } from "src/app/admin/services/permission-checker";
import { AccountServiceService } from "src/app/services/AccountService";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";


export abstract class BaseComponent {
    public formGroup: FormGroup;

    protected baseRouter: Router;
    protected baseActivatedRoute: ActivatedRoute;
    protected baseHttpClient: HttpClient;
    protected toastr: ToastrService;
    protected translate: TranslateService;
    protected dialogService: ConfirmationDialogService;
    protected modalService: NgbModal;

    protected subscription: Subscription[];

    private _errorMessage = new BehaviorSubject<string>('');
    constructor(allowAnonymous: boolean = false) {
        const injector = AppInjector.getInjector();

        this.toastr = injector.get(ToastrService);
        this.baseRouter = injector.get(Router);
        this.baseHttpClient = injector.get(HttpClient);
        this.baseActivatedRoute = injector.get(ActivatedRoute);
        this.translate = injector.get(TranslateService);
        this.dialogService = injector.get(ConfirmationDialogService);
        this.modalService = injector.get(NgbModal);

        this.subscription = [] as Subscription[];

        if (!allowAnonymous)
            App.auth.getPermissions(injector.get(AccountServiceService));
    }

    get form_Group() {
        return this.formGroup;
    }
    get errorMessage$() {
        return this._errorMessage.asObservable();
    }

    public navigateToURL(url: string) {
        this.baseRouter.navigateByUrl(url);
    }
    public navigateToUrlByData(url: string, data: any): void {
        this.baseRouter.navigateByUrl(url, {
            state: { data: data },
        });
    }

    //#region Form group validation
    submitted: boolean = false;

    scrollToValidation() {
        setTimeout(() => {
            const firstElementWithError = document.querySelector('.validation-message');
            if (firstElementWithError) {
                firstElementWithError.scrollIntoView({ behavior: 'smooth' });
            }
        }, 500);
        return true;
    }

    public isControlInvalid(controlName: string, fg: FormGroup): boolean {
        const control = fg.controls[controlName];
        return (
            control.invalid &&
            (control.dirty || control.touched || this.submitted)
        );
    }
    public controlHasError(
        validation: any,
        controlName: any,
        fg: FormGroup
    ): boolean {
        const control = fg.controls[controlName];
        return (
            control.hasError(validation) &&
            (control.dirty || control.touched || this.submitted)
        );
    }
    public isControlValid(controlName: string, fg: FormGroup): boolean {
        const control = fg.controls[controlName];
        return (
            control.valid &&
            (control.dirty || control.touched || this.submitted)
        );
    }
    //#endregion

    //#region Message handler
    public showSuccessMessage(message: string) {
        if (message) {
            this.toastr.success(message);
        }
    }
    public showErrorMessage(error: string) {
        console.log(`Error: ${error}`);
        this.toastr.error(error);
    }
    public showErrorMessages(errors: string[]) {
        console.log(`Errors: ${errors}`);
        errors.forEach((element) => {
            this.toastr.error(element);
        });
    }
    public logErrors(error: string, errors: string[]) {
        console.log(`Error: ${error}`);
        console.log(`Errors: ${errors}`);
    }
    public logException(error: any): any {
        this._errorMessage.next(error);
        console.log(`Exception: ${error}`);
        return of(null);
    }
    //#endregion

    //#reagion
    checkPermission(policy: string): boolean {
        return App.auth.isGranted(policy);
    }
    //#endreagion
}
